import api from "./api";

export const getAdminsByEnterprise = async (enterpriseId) => {
  try {
    const response = await api.get(`admin/all/house/${enterpriseId}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar administradores:", error);
    return [];
  }
};

export const createAdmin = async (adminData) => {
  try {
    const response = await api.post(`admin/house`, adminData);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar admin:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteAdmin = async (adminId) => {
  try {
    await api.delete(`admin/house/${adminId}`);
  } catch (error) {
    console.error("Erro ao remover admin:", error.response?.data || error.message);
    throw error;
  }
};

export const resetAdminPassword = async (adminId, newPassword) => {
  try {
    const response = await api.put(`admin/change-password/${adminId}`, { newPassword });
    return response.data;
  } catch (error) {
    console.error("Erro ao resetar senha:", error.response?.data || error.message);
    throw error;
  }
};